// extracted by mini-css-extract-plugin
export var saExpertsSection = "saExperts-module--saExpertsSection--mb9Os";
export var saExpertsGrid = "saExperts-module--saExpertsGrid--3TbcP";
export var saExpertsSliderItem = "saExperts-module--saExpertsSliderItem--sFHfY";
export var saLink = "saExperts-module--saLink--2tdnx";
export var saExpertsTitleContainer = "saExperts-module--saExpertsTitleContainer--1aaP-";
export var saExpertsText = "saExperts-module--saExpertsText--3hVGT";
export var saExpertsSlider = "saExperts-module--saExpertsSlider--1Jvds";
export var saExpertsSliderItemInner = "saExperts-module--saExpertsSliderItemInner--2B2M3";
export var saExpertsSliderItemImage = "saExperts-module--saExpertsSliderItemImage--P4wkM";
export var saExpertsSliderItemLogo = "saExperts-module--saExpertsSliderItemLogo--2hTTi";
export var saExpertsSliderItemName = "saExperts-module--saExpertsSliderItemName--10aOq";
export var saExpertsSliderItemPosition = "saExperts-module--saExpertsSliderItemPosition--gohS4";
export var saExpertsSliderItemTag = "saExperts-module--saExpertsSliderItemTag--2ulSF";
export var saExpertsSliderItemLocation = "saExperts-module--saExpertsSliderItemLocation--3GAHO";
export var btnPrev = "saExperts-module--btnPrev--2zhr_";
export var btnNext = "saExperts-module--btnNext--WHu_a";
export var saExpertsTitle = "saExperts-module--saExpertsTitle--1XlVj";